import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import '~/src/custom/js/utils/formhelper';
import validationRules from '../utils/validation';

class ContactUs {
	init() {
		this.bindEvents();
	}

	refreshEvents() {
		this.bindEvents();
		let selects = $('.form').find('select.js-select');
		if (selects.length > 0) {
			$(selects).each((_, el) => {
				window.FormTools.selectRefresh(el);
			});
		}
		$('input[type=text], textarea').blur();
	}

	bindEvents() {
		let inputList = $('.form').find('input');
         if (inputList.length > 0) {
            $(inputList).each((_, el) => {
				$(el).on('blur', this.blurInputState);
				$(el).on('focus', this.focusInputState);
            });
		}

		let textareaList = $('.form').find('textarea');
         if (textareaList.length > 0) {
            $(textareaList).each((_, el) => {
				$(el).on('blur', this.blurTextAreaState);
				$(el).on('focus', this.focusTextAreaState);
            });
		}
		let dropdownList = $('.form').find('select');
		if (dropdownList.length > 0) {
			$(dropdownList).each((_, el) => {
				$(el).parent().on('click', () => 
				{
					validationRules.selectValidate($(el));
				}); 
				setTimeout(() => {
					$(el).next().on('click', this.blurSelectState);
				}, 1000);
			});
		}
	}

	blurSelectState() {
		let label = $(this).parent().parent().prev('label');
		if ($(this).val().length <= 0) {
			$(label).removeClass('active-label');
		} else {
			$(label).addClass('active-label');
		}
	}

	blurInputState() {
		let label = $(this).parent().prev('label');
		if ($(this).val().length <= 0) {
			$(label).removeClass('active-label');
		} else {
			$(label).addClass('active-label');
		}
	}

	focusInputState() {
		let label = $(this).parent().prev('label');
			$(label).addClass('active-label');
	}

	focusTextAreaState() {
		let label = $(this).parent().parent().prev()
			.prev();
		$(label).addClass('active-label');
		let tooltip = $(this).parent().parent().prev();
		$(tooltip).toggleClass('active');
	}

	blurTextAreaState() {
		let label = $(this).parent().parent().prev()
			.prev();
		if ($(this).val().length <= 0) {
			$(label).removeClass('active-label');
		} else {
			$(label).addClass('active-label');
		}
		let tooltip = $(this).parent().parent().prev();
		$(tooltip).toggleClass('active');
	}
}

export default ContactUs;

$(() => {
	const ContacUs = new ContactUs();
	ContacUs.init();
	window.kentico.contactus = ContacUs;
});